import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface SproutIconProps {
  size?: number
  color?: string
  className?: string
  title?: string
}

/**
 * Sprout — the "Beginner" skill level. Mirrors the mobile Player Finder's
 * MaterialCommunityIcons `sprout` glyph so both platforms read the same.
 */
const SproutIcon: React.FC<SproutIconProps> = ({
  size = 16,
  color = colors.PRIMARY,
  className,
  title,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable='false'
    >
      {title ? <title>{title}</title> : null}
      <path
        d='M11 21v-6.1q-1.35.1-2.55-.35T6.2 13.1q-1.4-1.4-2.05-3.35T3.5 5.5q0-.35.02-.7t.08-.72q.35-.05.7-.08T5 4q2.3 0 4.25.65T12.6 6.7q.85.85 1.35 1.9t.7 2.2q.15-.15.32-.28t.38-.27q1.15-.7 2.55-1.02T21 8.9q.35 0 .68.02t.67.08q.05.35.08.68t.02.67q0 1.7-.32 3.12t-1.03 2.58q-.75 1.25-1.98 1.85t-2.62.6q-.4 0-.8-.05t-.8-.15q-.15.05-.3.08t-.3.07V21h-2Zm0-8.15v-.4q0-1-.35-1.87T9.6 9.05Q8.5 7.95 6.83 7.4T3.5 6.8q0 1.7.55 3.35t1.65 2.75q.75.75 1.7 1.05t1.9.2q-.4-.85-1.02-1.6t-1.38-1.35l-1.4-1.15 1.3-1.5 1.4 1.15q.9.75 1.62 1.7t1.18 2.05Zm4.6 3.2q.9.15 1.75-.08t1.45-.87q.75-.8 1.15-1.95t.45-2.35q-1.1.05-2.05.35t-1.6.85q-.6.5-.9 1.2t-.3 1.5v.5q0 .25.05.85Z'
        fill={color}
      />
    </svg>
  )
}

export default SproutIcon
